import { Document, Page, StyleSheet } from "@react-pdf/renderer";
import React from "react";
import AdvancesMainHeader from "../PDFComponents/AdvancesMainHeader";
import AmountContainer from "../PDFComponents/AmountContainer";
import AssoiciatedTableData from "../PDFComponents/AssoiciatedTableData";
import AssoiciatedTableHeader from "../PDFComponents/AssoiciatedTableHeader";
import Comments from "../PDFComponents/Comments";
import DetailHeader from "../PDFComponents/DetailHeader";
import EmployeeDetailList from "../PDFComponents/EmployeeDetailList";
import History from "../PDFComponents/History";
import PlainHeader from "../PDFComponents/PlainHeader";
import TripDetailsList from "../PDFComponents/TripDetailsList";
import LogoFooter from "../PDFComponents/LogoFooter";

const AdvancesTemplatesOne = ({ data, tripsHistory, CommentsData }) => {
  const styles = StyleSheet.create({
    page: {
      paddingTop: 60,
      paddingLeft: 40,
      paddingRight: 40,
      lineHeight: 1.5,
      flexDirection: "column",
    },
  });
  return (
    <Document>
      <Page size="A4" style={styles.page} wrap={false}>
        <AdvancesMainHeader data={data} />
        <DetailHeader title="Employee Details" />
        <EmployeeDetailList data={data} />
        <DetailHeader title="Advance Details" />
        <TripDetailsList data={data} />
        <AmountContainer data={data} />
        <PlainHeader title="Assoiciated Report" />
        <AssoiciatedTableHeader />
        <AssoiciatedTableData data={data} />
        <DetailHeader title="Comments" />
        <Comments data={CommentsData} />
        <DetailHeader title="History" />
        <History data={tripsHistory} />
        <LogoFooter />
      </Page>
    </Document>
  );
};

export default AdvancesTemplatesOne;
